import { STAR_SIGN } from '../types/enums'

export interface StarSignImagesPath {
  imagePath: string
  hoverImagePath: string
}

type StarSign2Images = {
  [key in STAR_SIGN]: StarSignImagesPath
}

export const starSign2images: StarSign2Images = {
  [STAR_SIGN.ariete]: {
    imagePath: 'oroscopo-loghi/01-Ariete.png',
    hoverImagePath: 'oroscopo-loghi/01-Ariete-on.png'
  },
  [STAR_SIGN.toro]: {
    imagePath: 'oroscopo-loghi/02-Toro.png',
    hoverImagePath: 'oroscopo-loghi/02-Toro-on.png'
  },
  [STAR_SIGN.gemelli]: {
    imagePath: 'oroscopo-loghi/03-Gemelli.png',
    hoverImagePath: 'oroscopo-loghi/03-Gemelli-on.png'
  },
  [STAR_SIGN.cancro]: {
    imagePath: 'oroscopo-loghi/04-Cancro.png',
    hoverImagePath: 'oroscopo-loghi/04-Cancro-on.png'
  },
  [STAR_SIGN.leone]: {
    imagePath: 'oroscopo-loghi/05-Leone.png',
    hoverImagePath: 'oroscopo-loghi/05-Leone-on.png'
  },
  [STAR_SIGN.vergine]: {
    imagePath: 'oroscopo-loghi/06-Vergine.png',
    hoverImagePath: 'oroscopo-loghi/06-Vergine-on.png'
  },
  [STAR_SIGN.bilancia]: {
    imagePath: 'oroscopo-loghi/07-Bilancia.png',
    hoverImagePath: 'oroscopo-loghi/07-Bilancia-on.png'
  },
  [STAR_SIGN.scorpione]: {
    imagePath: 'oroscopo-loghi/08-Scorpione.png',
    hoverImagePath: 'oroscopo-loghi/08-Scorpione-on.png'
  },
  [STAR_SIGN.sagittario]: {
    imagePath: 'oroscopo-loghi/09-Sagittario.png',
    hoverImagePath: 'oroscopo-loghi/09-Sagittario-on.png'
  },
  [STAR_SIGN.capricorno]: {
    imagePath: 'oroscopo-loghi/10-Capricorno.png',
    hoverImagePath: 'oroscopo-loghi/10-Capricorno-on.png'
  },
  [STAR_SIGN.acquario]: {
    imagePath: 'oroscopo-loghi/11-Acquario.png',
    hoverImagePath: 'oroscopo-loghi/11-Acquario-on.png'
  },
  [STAR_SIGN.pesci]: {
    imagePath: 'oroscopo-loghi/12-Pesci.png',
    hoverImagePath: 'oroscopo-loghi/12-Pesci-on.png'
  }
}
